var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: _vm.detail.title,
      visible: _vm.visible,
      center: "",
      width: "800px",
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function ($event) {
        _vm.visible = $event;
      },
      close: _vm.cancel
    }
  }, [_c("div", {
    staticClass: "w-e-text",
    domProps: {
      innerHTML: _vm._s(_vm.replaceContent)
    }
  }), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("确 定")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };